import React from 'react';
import {NavLink} from 'react-router-dom';
import './SportsMarkets.css';
export default function SportNavigation(){return <nav className="sport-tabs" aria-label="Sports"><NavLink to="/" end>Horse Racing</NavLink><NavLink to="/greyhounds">Greyhounds</NavLink>{['afl','nrl','nba'].map(s=><NavLink key={s} to={'/sports/'+s}>{s.toUpperCase()}</NavLink>)}</nav>;}
